<template>
    <div class="box">
        <el-image style="width: 70%;" :src="imgurl2" fit="fill"></el-image>
        <el-image style="width: 60%;" :src="imgurl" fit="fill"></el-image>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imgurl: require('../../assets/images/2.png'),
            imgurl2: require('../../assets/images/5.png')
        }
    }
}
</script>

<style scoped>
.box {
    width: 100%;
    text-align: center;
}
</style>